import { ButtonTag } from '~/components'
import { Location, useOrderedLocations } from '~/storm'

type Props = {
    assignedRoomCodes: string[]
    onLocationClick?: (location: Location) => void
}

export const LocationDefinitionList = ({ assignedRoomCodes, onLocationClick }: Props) => {
    const locations = useOrderedLocations()

    return (
        <div className="grid grid-cols-3 gap-2">
            {locations.map(location => (
                <ButtonTag
                    key={location.room_code}
                    className={assignedRoomCodes.includes(location.room_code) ? 'border border-brand-ring' : ''}
                    colorType="room"
                    label={location.room_code}
                    fillType="all"
                    onClick={() => onLocationClick?.(location)}
                />
            ))}
        </div>
    )
}
